import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { validationClasses } from '@/utils/errors';
import { removeDuplicates } from '@/utils/resultsHelper';

const listItems = (options, text) => options.concat(text.filter((item) => options.indexOf(item) < 0)).map((option) => (
  {
    key: option,
    text: option,
    value: option,
  }
));

const FormMultiDropdown = ({
  autoFocus,
  disabled,
  error,
  field,
  onChange,
  text,
  upward,
}) => (
  <Dropdown
    allowAdditions
    autoFocus={autoFocus}
    className={validationClasses(error, 'aridhia-form-multi-dropdown aridhia-h4 aridhia-tag aridhia-is-edit-mode')}
    disabled={disabled}
    fluid
    multiple
    onChange={(e, { value }) => { onChange(removeDuplicates(value, true)); }}
    options={listItems(field.options || [], text || [])}
    placeholder={field.placeholder}
    search
    selection
    upward={upward}
    value={text || []}
  />
);

export default FormMultiDropdown;
